import { render } from "./ProjectsTab.vue?vue&type=template&id=1a255cd8&scoped=true"
import script from "./ProjectsTab.vue?vue&type=script&lang=js"
export * from "./ProjectsTab.vue?vue&type=script&lang=js"

import "./ProjectsTab.vue?vue&type=style&index=0&id=1a255cd8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a255cd8"]])

export default __exports__